export default __webpack_public_path__ + "static/media/work9.b0b31665.jpeg";